export function getShareLinkDetailUrl(id: string): string {
  return `/api/share-links/${id}`;
}

export function getShareLinkUrl(id: string): string {
  return `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/s/${id}/`;
}

export function getShareLinkEmbedUrl(id: string): string {
  return `${getShareLinkUrl(id)}embed/`;
}

export function getShareLinkoEmbedUrl(id: string): string {
  const shareLinkUrl = encodeURIComponent(getShareLinkUrl(id));
  const url = `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/api/oembed`;
  return `${url}?url=${shareLinkUrl}&format=json`;
}

export function getShareLinkIsActiveUrl(id: string): string {
  return `/api/share-links/${id}/is-active`;
}
